module.exports = __webpack_public_path__ + "fonts/Linearicons-Free.03e91f12.woff2";